module.exports = __webpack_public_path__ + "static/img/2.7b2c04b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Eau/2.jpg
// module id = BNjc
// module chunks = 0